var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.475 14.475C8.3375 14.3375 8.2655 14.1625 8.259 13.95C8.253 13.7375 8.31875 13.5625 8.45625 13.425L12.1312 9.75001H3.75C3.5375 9.75001 3.35925 9.67801 3.21525 9.53401C3.07175 9.39051 3 9.21251 3 9.00001C3 8.78751 3.07175 8.60926 3.21525 8.46526C3.35925 8.32176 3.5375 8.25001 3.75 8.25001H12.1312L8.45625 4.57501C8.31875 4.43751 8.253 4.26251 8.259 4.05001C8.2655 3.83751 8.3375 3.66251 8.475 3.52501C8.6125 3.38751 8.7875 3.31876 9 3.31876C9.2125 3.31876 9.3875 3.38751 9.525 3.52501L14.475 8.47501C14.55 8.53751 14.6033 8.61551 14.6348 8.70901C14.6658 8.80301 14.6813 8.90001 14.6813 9.00001C14.6813 9.10001 14.6658 9.19376 14.6348 9.28126C14.6033 9.36876 14.55 9.45001 14.475 9.52501L9.525 14.475C9.3875 14.6125 9.2125 14.6813 9 14.6813C8.7875 14.6813 8.6125 14.6125 8.475 14.475V14.475Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalArrowRight);
export default __webpack_public_path__ + "static/media/modal-arrow-right.d37d8dcad47a52f5b929b28f70bc679b.svg";
export { ForwardRef as ReactComponent };